import React from 'react';
import { Box } from '@common-fe/common-fe';

import BankingBalanceOrgDetailsContainer from '@/modules/employer/components/BankingBalance/components/BankingBalanceOrganizationDetails/BankingBalanceOrgDetails.container';
import theme from '@/styles/theme';

import Topbar from '../modules/core/components/Topbar';

const BankingBalanceOrgDetailsPage = () => (
  <Box width="100%" height="fit-content">
    <Topbar />
    <Box align="center" margin={{ top: 'medium' }} pad={{ bottom: 'spacing72' }}>
      <Box width={theme.defaultContentWidth}>
        <BankingBalanceOrgDetailsContainer />
      </Box>
    </Box>
  </Box>
);

export default BankingBalanceOrgDetailsPage;
